<script setup>
import { useUserStore } from '@/stores/user'
import { getDashboardResourceStats } from '@/services/userService'
import { formatNumberAsWholeNumber } from '@/utils/numeralHelper.ts'
import Filters from '@/filters'
import { onMounted, ref } from 'vue'

const userStore = useUserStore()
const loading = ref(true)
const statistics = ref([
  {
    title: 'Next Billing In',
    stats: 'N/A',
    icon: 'tabler-chart-pie-2',
    color: 'primary',
    name: 'billing',
  },
  // {
  //   title: 'Bandwidth',
  //   stats: '0 GB / 0 GB',
  //   icon: 'tabler-users',
  //   color: 'info',
  // },
  {
    title: 'Disk',
    stats: '0 GB / 0 GB',
    icon: 'tabler-shopping-cart',
    color: 'error',
  },
  {
    title: 'Visits',
    stats: '0 / 0',
    icon: 'tabler-currency-dollar',
    color: 'success',
  },
])
const getBillingDays = async () => {
  const nextDate = userStore.userProfile?.nextRenewalDate
  if (nextDate) {
    const res = Filters.date.getDaysFromNowToSpecificDate(nextDate)
    const billingObj = statistics.value.find(
      (statsObj) => statsObj.name.toLowerCase() === 'billing',
    )
    billingObj.stats = res
  }
}
const getResourceStats = async () => {
  try {
    const data = await getDashboardResourceStats()
    if (data.siteStorageUsage) {
      const diskData = data.siteStorageUsage?.[0] ?? null
      if (diskData) {
        const diskObj = statistics.value.find(
          (statsObj) => statsObj.title.toLowerCase() === 'disk',
        )
        diskObj.stats = `${
          diskData?.total_usage_recorded
            ? (diskData?.total_usage_recorded / 1024).toFixed(2)
            : 0
        } GB / ${
          diskData?.total_allowed_usage
            ? diskData?.total_allowed_usage / 1024
            : 0
        } GB`
      }
    }
    if (data.siteViewUsage) {
      const visitsData = data.siteViewUsage?.[0] ?? null
      if (visitsData) {
        const visitsObj = statistics.value.find(
          (statsObj) => statsObj.title.toLowerCase() === 'visits',
        )
        visitsObj.stats = `${
          visitsData?.total_usage_recorded
            ? formatNumberAsWholeNumber(visitsData?.total_usage_recorded)
            : 0
        } / ${
          visitsData?.total_allowed_usage
            ? formatNumberAsWholeNumber(visitsData?.total_allowed_usage)
            : 0
        }`
      }
    }
  } catch (e) {
    return
  }
}
onMounted(async () => {
  await getResourceStats()
  await getBillingDays()
  loading.value = false
})
</script>

<template>
  <VCard title="Resource Usage">
    <VCardText class="pt-6">
      <VRow>
        <VCol
          v-for="item in statistics"
          :key="item.title"
          cols="6"
          md="4"
        >
          <div class="d-flex">
            <VAvatar
              :color="item.color"
              variant="tonal"
              size="42"
              class="me-3"
            >
              <VIcon
                size="24"
                :icon="item.icon"
              />
            </VAvatar>

            <div class="d-flex flex-column">
              <VListItemTitle class="font-weight-medium">
                {{ item.stats }}
              </VListItemTitle>
              <VListItemSubtitle>
                {{ item.title }}
              </VListItemSubtitle>
              <!--              <span class="title font-weight-regular">{{ item.stats }}</span>-->
              <!--              <span class="text-caption">-->
              <!--                {{ item.title }}-->
              <!--              </span>-->
            </div>
          </div>
        </VCol>
      </VRow>
    </VCardText>
  </VCard>
</template>